module.exports = __webpack_public_path__ + "img/avatar0.a80a3279.png";